import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import PrimaryButton from "../Button/PrimaryButton";
import { X } from "lucide-react";

export default function CustomDialog({
  visible,
  setVisible,
  heading,
  detail,
  src,
  onSubmit,
  onHide,
  onCancel,
  submitLabel = "Confirm",
  cancelLabel = "No",
  children,
  classNames,
  btnClass,
  loading,
}) {
  // Prevent background scrolling when dialog is open
  useEffect(() => {
    if (visible) {
      // Store original style to restore later
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";

      // Return cleanup function to restore original style
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [visible]);

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      maskStyle={{ background: "rgba(0,0,0,0.5)" }}
      // closable={false}
      className={`rounded-[10px] shadow-lg ${classNames}`}
      // style={{ width: "500px", borderRadius: "15px" }}
      // breakpoints={{ "960px": "75vw", "641px": "94vw" }}
      showIcon={true}
    >
      <div className="bg-[#5882C126] bg-blur flex items-center rounded-lg">
        {/* <button
          className="border rounded-[50%] p-1 absolute z-50 top-0 mt-2 right-1 cursor-pointer"
          onClick={() => {
            setVisible && setVisible(false);
            onHide && onHide();
          }}
        >
          <X size={14} />
        </button> */}
        {src && <img src={src} alt="" className="mb-3 w-12 h-12" />}

        {heading && (
          <h2 className="text-2xl font-semibold text-black">{heading}</h2>
        )}
        {detail && <p className="text-md text-grey-color my-2">{detail}</p>}

        {children && <div className="w-full mt-4 mb-4">{children}</div>}

        {onSubmit && !onCancel && (
          <PrimaryButton
            label={submitLabel}
            className={`bg-gradient px-6 mt-4 ${btnClass} w-full`}
            onClick={() => {
              onSubmit ? onSubmit() : setVisible(false);
            }}
            loading={loading}
          />
        )}

        {onSubmit && onCancel ? (
          <div className="flex gap-3 w-full">
            <div className="w-full">
              <Button
                label={cancelLabel}
                onClick={() => onCancel && onCancel()}
                className="p-button-outlined p-button-secondary rounded-xl w-full "
              />
            </div>
            <div className="w-full">
              <PrimaryButton
                label={submitLabel}
                onClick={() => onSubmit && onSubmit()}
                className={`custom-dialog-btn bg-gradient w-full`}
                loading={loading}
              />
            </div>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}
